import PropTypes from 'prop-types';
import React from 'react';

/**
 * Theme-aware Suspense fallback that prevents white flash on lazy-loaded routes.
 *
 * Uses CSS custom properties from tokens.css so it automatically matches
 * whichever theme (light / dark / high-contrast) is active on <html>.
 * The inline <script> in index.html sets data-theme synchronously before
 * React mounts, so these variables are always correct — no flash.
 */
function DarkSuspenseFallback({ height }) {
  return (
    <div
      style={{
        minHeight: height ?? '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--color-background-primary)',
        color: 'var(--color-text-secondary)',
        transition: 'background-color 0.15s ease, color 0.15s ease',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        {/* Spinner */}
        <div
          style={{
            width: 36,
            height: 36,
            margin: '0 auto 12px',
            border: '3px solid var(--color-border-light)',
            borderTopColor: 'var(--color-primary-main)',
            borderRadius: '50%',
            animation: 'vh-spin 0.7s linear infinite',
          }}
        />
        <div
          style={{
            fontSize: 'var(--typography-font-size-sm)',
            fontFamily: 'var(--typography-font-family-primary)',
            letterSpacing: 'var(--typography-letter-spacing-wide)',
          }}
        >
          Loading…
        </div>
      </div>

      {/* Keyframes injected once via <style> — React deduplicates identical tags */}
      <style>{`
        @keyframes vh-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

DarkSuspenseFallback.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default DarkSuspenseFallback;
